const SignUp = () => {
    return (
        <div className="h-screen w-full bg-gray-400 ">
            
        </div>
    );
}

export default SignUp;